<template lang="pug">
  div(class="document-sign-list-icon")
    template(v-if="isDocumentLoading")
      span(class="text-12px document-sign-list-icon__text signing") {{ loadingText }}
      v-progress-circular(
        width="2"
        size="20"
        color="#8F257D"
        :indeterminate="true"
      )
    template(v-else-if="isErrorDocument")
      e-svg-icon close-circle-red
    template(v-else-if="isSkippedDocument")
      v-tooltip(bottom)
        template(#activator="{ on }")
          div(
            v-on="on"
            class="d-flex align-center"
          )
            span(class="text-12px document-sign-list-icon__text skipped") {{ $t('Signed before') }}
            e-svg-icon alert-triangle
        span {{ $t('Document has signed already') }}
    template(v-else-if="isSignedDocument")
      span(class="text-12px succeed document-sign-list-icon__text") {{ signedText }}
      e-svg-icon check-circle-green
    template(v-else)
      v-progress-circular(
        width="2"
        size="20"
      )
</template>

<script>
export default {
  name: 'BlockDocumentsSignListIcons',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['eds', 'stamp'].includes(value)
    },
    document: {
      type: Object,
      default: () => ({})
    },
    documentsStates: {
      type: Object,
      default: () => ({})
    },
    statuses: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isStampType() {
      return this.type === 'stamp'
    },
    isDocumentLoading() {
      return this._.get(
        this.documentsStates[this.document.id],
        this.isStampType ? 'stampLoading' : 'loading'
      )
    },
    isErrorDocument() {
      return (
        this._.get(
          this.documentsStates[this.document.id],
          this.isStampType ? 'stampStatus' : 'status'
        ) === this.statuses.error
      )
    },
    isSkippedDocument() {
      return (
        this._.get(
          this.documentsStates[this.document.id],
          this.isStampType ? 'stampStatus' : 'status'
        ) === this.statuses.skipped
      )
    },
    isSignedDocument() {
      return (
        this._.get(
          this.documentsStates[this.document.id],
          this.isStampType ? 'stampStatus' : 'status'
        ) === this.statuses.signed
      )
    },
    loadingText() {
      return this.isStampType ? this.$t('Applying stamp') : this.$t('Signing in the process')
    },
    signedText() {
      return this.isStampType ? this.$t('Stamp key applied') : this.$t('EDS key signed')
    }
  }
}
</script>

<style scoped lang="scss">
.document-sign-list-icon {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;

  &__text {
    padding-right: 8px;
    &.signing {
      color: $primary;
    }
    &.skipped {
      color: #d2ae22;
    }
    &.error-text {
      color: $danger;
    }
  }
}
</style>
